import styled from 'styled-components';

import { colors, transition } from 'theme';

import { ButtonWithStyles } from './ButtonWithStyles';

export const LegacyPrimaryButton = styled(ButtonWithStyles).attrs({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $textColor: (props: any) =>
    props.color || (props.reverse ? colors.brandBlue : colors.white),
})<{ $transparent?: boolean }>`
  transition: all ${transition};
  text-decoration: none;
  color: ${(props) => props.$textColor};
  background: ${(props) => (props.reverse ? colors.white : colors.brandBlue)};
  border: 1px solid ${colors.brandBlue};
  ${(props) =>
    props.$transparent &&
    `
  background: transparent;
  border: 1px solid ${colors.white};`}

  &:hover {
    background-color: ${colors.hoverBlue};
    border: 1px solid ${colors.hoverBlue};
    color: ${(props) => props.$textColor};
    text-decoration: none;
  }
  &:disabled {
    &:hover {
      background-color: ${colors.brandBlue};

      ${(props) =>
        props.$transparent &&
        `
  background-color: transparent;
`}
    }
  }
`;
